import gql from 'graphql-tag';

export const CloneParticipantDocument = gql`
  mutation CloneParticipantDocument(
    $organizationId: ID!
    $participantId: ID!
    $participantDocumentId: ID!
  ) {
    cloneParticipantDocument(
      organizationId: $organizationId
      participantId: $participantId
      participantDocumentId: $participantDocumentId
    ) {
      id
    }
  }
`;
